<div class="page">
  <app-page-header itemName="{{ userFullName }}" page-title="users.detail.pageTitle"></app-page-header>
  <div class="page-content">
    <div class="row mb-2" *ngIf="adminCompanyId">
      <div class="col-12 col-md-7 col-lg-8">
        <a [routerLink]="'../../../../companies/detail/' + adminCompanyId " mat-raised-button color="primary"
          matTooltip="{{ 'common.words.clickToOpen' | translate }}">
          <mat-icon fontSet="fal" fontIcon="fa-chevron-left"></mat-icon>
          {{ 'common.cta.back' | translate }}
        </a>
      </div>
    </div>

    <!-- User card -->
    <mat-card class="custom-card">
      <mat-card-title *ngIf="loggedUser && (loggedUser._id !== user.getId())">
        <mat-icon class="mr-2" fontSet="fas" fontIcon="fa-user"></mat-icon>
        <strong class="h5">{{ userFullName }}</strong>
      </mat-card-title>
      <mat-card-title *ngIf="loggedUser && (loggedUser._id === user.getId())">
        <mat-icon class="mr-2" fontSet="fas" fontIcon="fa-user"></mat-icon>
        {{ 'users.detail.editTab.myProfile' | translate }}
      </mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <app-creator-updator-box [data]="user"></app-creator-updator-box>
          <div class="row my-5 h6 text-muted font-weight-normal" *ngIf="user">
            <div class="col-12 col-sm-6">
              <mat-icon class="mr-2" fontSet="fas" fontIcon="fa-envelope" color="primary">
              </mat-icon>{{ user.email }}
            </div>
            <div class="col-12 col-sm-6">
              <mat-icon class="mr-2" fontSet="fas" fontIcon="fa-tag" color="primary">
              </mat-icon>{{ displayedRole ? translateService.instant('roles.types.' + displayedRole.role.type.toLowerCase()).toUpperCase() : '' }}
            </div>
          </div>
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- Password card -->
    <mat-card *ngIf="loggedUser && (loggedUser._id === user.getId())" class="custom-card mt-4">
      <mat-card-title>
        <mat-icon class="mr-2" fontSet="fas" fontIcon="fa-user"></mat-icon>
        {{ 'users.detail.editTab.myPassword' | translate }}
      </mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="paswordCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <form [formGroup]="formPassword" (ngSubmit)="onFormPasswordSubmit(modelPassword)">
              <formly-form [form]="formPassword" [fields]="fieldsPassword" [model]="modelPassword" [options]="optionsPassword"></formly-form>
              <mat-spinner-button role="submit" [options]="formPasswordBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div> 
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  
    <!-- Delete card -->
    <mat-card *ngIf="user && loggedUser && loggedUserPermissions.includes('canDeleteUsers')" class="custom-card mt-4">
      <mat-card-title>{{ 'users.detail.deleteTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.deleteTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="deleteCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <p>{{ 'common.words.deleteTabWarning' | translate }}</p>
          <mat-spinner-button (btnClick)="onDelete()" [options]="deleteBtnOptions"> </mat-spinner-button>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->